import { useEffect, useState } from 'react';

/**
 * Geeft een tijdstempel terug die elke `intervalMs` opschuift, zodat een
 * component die op de WANDKLOK rekent (leeftijd, aftelling, "X s geleden")
 * ook hertekent wanneer er geen nieuwe data binnenkomt.
 *
 * Waarom dit bestaat (wachtrij #181, audit cy87): de snapshot-leeftijd in
 * FlowSVG werd gememoiseerd op de tijdstempel die hij bewaakt. `zbs-loop` en
 * `zbs-api` zijn losse services, dus een stilgevallen regellus laat de API
 * gewoon 200 geven met dezelfde oude rij. `lastUpdateIso` verandert dan niet
 * meer, de memo wordt nooit herberekend, en de kop bleef eeuwig "3s geleden"
 * tonen — precies in het geval waarvoor die indicator bestaat. Hetzelfde geldt
 * bij een dode API: `usePolling` houdt de laatst bekende data vast.
 *
 * Een verborgen tab wordt door de browser zelf tot ~1 tick/minuut afgeknepen;
 * een extra visibility-rem is hier niet nodig, want er hangt geen netwerkwerk
 * aan deze timer.
 */
export function useWallClockTick(intervalMs = 5_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);
  return now;
}
